module.exports = __webpack_public_path__ + "img/play_left.a447c938.png";